module.exports = __webpack_public_path__ + "img/img1.753b7e69.jpg";